import { useQuery } from "@apollo/client/react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { adaptDelegacionReclamosArray } from "../../../adapters/delegacionAdapter";
import { TextInput } from "../../../components/textInput/TextInput";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { GET_ESTADO_PACIENTE } from "../../../data/graphQL/queries/Pacientes/getEstadoPaciente";
import { DateInput } from "../../../components/dateInput/DateInput";
import { CustomButton } from "../../../components/customButton/CustomButton";
import { adaptEstadoPacienteArray } from "../../../adapters/estadoPaciente";
import { ID_ESTADO_PACIENTE_ALTA } from "./GestionAsistencialContent";
import { useEffect } from "react";

const userId = sessionStorage.getItem("idUsuario");
const ID_ESTADO_PACIENTE_NUEVO = 2;

export function GestionAsistencialFiltersHeader({
  filters,
  handleChange,
  handleTextClean,
  handleTextFilter,
  handleSearch,
  handleEstadoPacienteFilter,
  handleDelegacionChange,
  handleChangeFechaDesde,
  handleChangeFechaHasta,
  estadoPaciente,
  delegaciones,
  setEstadoPaciente,
  setDelegaciones
}) {
  const { data: delegacionesData } = useQuery(GET_DELEGACIONES_BY_USUARIO, {
    variables: { idUsuario: JSON.parse(userId, 10) }
  });

  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionReclamosArray(delegacionesData, false));
  }, [delegacionesData]);

  const { data: dataEstadoPaciente } = useQuery(GET_ESTADO_PACIENTE);

  useEffect(() => { 
    if (!dataEstadoPaciente) return;
    setEstadoPaciente(adaptEstadoPacienteArray(dataEstadoPaciente));
  }, [dataEstadoPaciente]);

  const handleEstadoChange = (event) => {
    handleChange(event);
    handleEstadoPacienteFilter(event.target.value);
  };

  return (
    <Grid container spacing={2} mb="25px">
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormControl sx={{ bgcolor: "white", width: "100%" }} size="small">
          <InputLabel id="select-delegacion">Delegación</InputLabel>
          <Select
            labelId="select-delegacion"
            options={delegaciones}
            label="Delegación"
            onChange={handleDelegacionChange}
            value={filters?.idDelegacion || ""}
            name="idDelegacion">
            
            {delegaciones.map((delegacion) => {
              return (
                <MenuItem key={delegacion.id} value={delegacion.id}>
                  {" "}
                  {delegacion.displayName}{" "}
                </MenuItem>);

            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <FormControl sx={{ bgcolor: "white", width: "100%" }} size="small">
          <InputLabel id="select-area-estado-paciente">
            Estado paciente
          </InputLabel>
          <Select
            labelId="select-area-estado-paciente"
            options={estadoPaciente}
            label="Tipo estado paciente"
            onChange={handleEstadoChange}
            value={filters?.idEstadoPaciente || ""}
            name="idEstadoPaciente">
            
            {estadoPaciente.filter((x) => x.id !== ID_ESTADO_PACIENTE_NUEVO).map((tipo) => {
              return (
                <MenuItem key={tipo.id} value={tipo.id}>
                  {" "}
                  {tipo.displayName}{" "}
                </MenuItem>);

            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TextInput
          searchIcon
          label="Buscar"
          name="txtFiltro"
          onClearButtonClick={handleTextClean}
          value={filters?.txtFiltro}
          onChange={handleChange}
          onKeyUp={handleTextFilter} />
        
      </Grid>
      {filters?.idEstadoPaciente === ID_ESTADO_PACIENTE_ALTA &&
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <DateInput
          label="Fecha desde"
          value={filters?.fechaDesde}
          onChange={(value) => handleChangeFechaDesde(value, "fechaDesde")} />
        
        </Grid>
      }
      {filters?.idEstadoPaciente === ID_ESTADO_PACIENTE_ALTA &&
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <DateInput
          label="Fecha hasta"
          value={filters?.fechaHasta}
          onChange={(value) => handleChangeFechaHasta(value, "fechaHasta")} />
        
        </Grid>
      }
      <Grid sx={{ textAlign: 'right' }} size={{ xs: 12, sm: 6, md: 3 }}>
        <CustomButton size="small" onClick={handleSearch}>
          Buscar
        </CustomButton>
      </Grid>
    </Grid>);

}